export default __webpack_public_path__ + "static/media/share-icon.d15f5bc9.svg";